import { SharedModule } from '../../shared/shared.module';
import { StudentsForImpactComponent } from './students-for-impact.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StudentsForImpactListModule } from './students-for-impact-list/students-for-impact-list.module';
import { StudentsForImpactDetailsModule } from './students-for-impact-details/students-for-impact-details.module';
import { StudentsForImpactEditionModule } from './students-for-impact-edit/students-for-impact-edition.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    ImageCropperModule,
    SharedModule,
    BsDatepickerModule,
    StudentsForImpactListModule,
    StudentsForImpactDetailsModule,
    StudentsForImpactEditionModule
  ],
  declarations: [StudentsForImpactComponent],
  exports: [StudentsForImpactComponent],
  entryComponents: []
})
export class StudentsForImpactModule { }